const keyPath =
    <T>(path: string) =>
    (data: {}) => {
        try {
            return path.split('.').reduce((acc, curr) => acc[curr], data) as T;
        } catch (e) {
            throw Error(`Could not resolve keyPath [${keyPath}].`);
        }
    };

export default keyPath;
